import { postRenameAudience } from '../services';
export const renameAudience = (params) => postRenameAudience(params).then(response => formatResponse(response.data));
const formatResponse = (response) => {
    return response.success;
};
